import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { CrearSedeDto } from '../shared/models/crear-sede-dto';
import { ErrorDto } from '../shared/models/error-dto';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { SesionService } from '../shared/services/sesion.service';
import { BuscarSedeDto } from '../shared/models/buscar-sede-dto';import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-crud-ciudad',
  templateUrl: './crud-ciudad.component.html',
  styleUrls: ['./crud-ciudad.component.css']
})
export class CrudCiudadComponent implements OnInit {
  principalForm = this.formBuilder.group({
    CiudadControl: new FormControl(),
    CodioIATAControl: new FormControl()
  });

  companias: Compania[];
  companiasSeleccionadas: Compania[] = new Array<Compania>();
  ciudades: Ciudad[]= new Array<Ciudad>();
  ciudadesFiltradas: Ciudad[];
  ciudadSeleccionada: Ciudad = new Ciudad();
  sedeCrear: Sede = new Sede();
  crearSedeDto: CrearSedeDto = new CrearSedeDto();
  nombreSede = '';
  modalRef: NgbModalRef;
  errorDto: ErrorDto;
  mensajeAlerta = '';
  sedes: BuscarSedeDto[] = new Array<BuscarSedeDto>();
  idCiudadBuscar = -1;
  nombreSedeBuscar = '-1';
  listaIdCompanias: number[] = new Array<number>();
  sedeSeleccionada: BuscarSedeDto = new BuscarSedeDto();
  indexSeleccionado: number;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private sesionService: SesionService, private modalService: NgbModal,
    private formBuilder: FormBuilder) { }

  ngOnInit() {

    console.log(this.principalForm);
    this.listarCiudades();
  }

  public listarCiudades(): void {
    this.ciudadService.listarCiudades().subscribe(
      resultado => {
        this.ciudades = resultado;
        this.ciudadesFiltradas = this.ciudades;
      }
    );
  }


  public filterCiudades(event) {
    this.ciudadesFiltradas = [];
    for (let i = 0; i < this.ciudades.length; i++) {
      const ciudad = this.ciudades[i];
      if (ciudad.nombreCiudad.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.ciudadesFiltradas.push(ciudad);
      }
    }
    
    this.ciudadSeleccionada = new Ciudad();
    this.ciudadSeleccionada.nombreCiudad=event.query;
    this.ciudadSeleccionada.codigoIATA="";  
    
  }

  
  public validarCiudadSeleccionada() {
    if (typeof this.ciudadSeleccionada == 'string') {
      const nombreCiudad = this.ciudadSeleccionada;
      this.ciudadSeleccionada = new Ciudad();
      this.ciudadSeleccionada.nombreCiudad = nombreCiudad;
    }
  }

  
  public inicializarParametrosBuscar() {
    this.idCiudadBuscar = -1;
  }

  crearModificarCiudad() {
    swal({
      title: "Procesando ",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)
    this.ciudadService.crearCiudad(this.ciudadSeleccionada).subscribe(
      resultado => {
        this.ciudadSeleccionada = resultado;
        if (this.ciudadSeleccionada.idCiudad!=0) {
          swal("Se creo correctamente", "La ciudad fue creada/modificada correctamente : \n" + this.ciudadSeleccionada.nombreCiudad, "success").then(function () {
            // Redirect the user
            window.location.href = "/#/solicitar-ip";
          });
        }
        else {
          swal("Se presento un error al crear/modificar la ciudad", ""+this.ciudadSeleccionada.nombreCiudad, "error").then(function () {
            // Redirect the user
            window.location.reload();
          })
        }
      }, error => {
        swal("Se presento un error de comunicación intente nuevamente", "", "error").then(function () {
          // Redirect the user
          window.location.reload();
        })
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/crud-ciudad/crud-ciudad.component.ts